import { Localized } from "@fluent/react"
import { Box, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import { DefaultCompanySetting } from "./defaultCompanySettingsApi";
import { useEffect, useState } from "react";
import { CancelButton } from "../../../app/components/CancelButton";
import { CopyToClipboardButton } from "../../../app/components/CopyToClipboardButton";
import { DownloadButton } from "../../../app/components/DownloadButton";

interface GenerateCodeDefaultCompanySettingsDialogProps {
    companySettings?: DefaultCompanySetting[];
    onCancel: () => void;
}

export const GenerateCodeDefaultCompanySettingsDialog: React.FC<GenerateCodeDefaultCompanySettingsDialogProps> = ({ companySettings, onCancel }) => {
    const [code, setCode] = useState("");

    useEffect(() => {
        const escapeSql = (value: string) => value.replace(/'/g, "''");

        const inserts = companySettings?.map(s => {
            const id = escapeSql(s.id);
            const type = escapeSql(s.type);
            const code = escapeSql(s.code);
            const value = escapeSql(s.value);

            return `UPDATE [dbo].[DefaultCompanySettings] SET Type = '${type}', Code = '${code}', Value = '${value}', IsActive = ${s.isActive ? 1 : 0}, IsFixed = ${s.isFixed ? 1 : 0} WHERE Id = '${id}';\nINSERT INTO [dbo].[DefaultCompanySettings] ([Id], [Type], [Value], [IsActive], [IsFixed], [CreateDate], [CreatedBy], [ModifiedBy], [ModifyDate], [Code]) SELECT '${id}', '${type}', '${value}', ${s.isActive ? 1 : 0}, ${s.isFixed ? 1 : 0}, GETDATE(), 'super', 'super', GETDATE(), '${code}' WHERE NOT EXISTS (SELECT 1 FROM [dbo].[DefaultCompanySettings] WHERE Id = '${id}');`
        }).join("\n\n");

        setCode(inserts ?? "");
    }, [companySettings]);

    return (
        <>
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Localized id="default-company-settings-generate-script">
                        <span>_Wygeneruj skrypt</span>
                    </Localized>
                    <div>
                        <DownloadButton name="migration_defaultCompanySettings" value={code} />
                        <CopyToClipboardButton value={code} />
                    </div>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Typography
                    component="pre"
                    sx={{
                        padding: 2,
                        fontFamily: "monospace"
                    }}
                >
                {`${code}`}
                </Typography>
            </DialogContent>
            <DialogActions>
                <CancelButton loading={false} onClick={onCancel} />
            </DialogActions>
        </>               
    )
}